import * as types from './types';
import SPBackend from '../../../services/SPBackend';
import { log } from '../../../utils/jsUtils';
import { setBilling } from '../billing/actions';

export const setOpenSupportDialog = (open) => ({
  type: types.SET_OPEN_SUPPORT_DIALOG,
  payload: open
});

export const setPlanInfo = (planInfo) => ({
  type: types.SET_PLAN_INFO,
  payload: planInfo
});

export const setSubscriptionInfo = (info) => ({
  type: types.SET_SUBSCRIPTION_INFO,
  payload: info
});

export const setAccountUsage = (usage) => ({
  type: types.SET_ACCOUNT_USAGE,
  payload: usage
});

// Note: setBilling is now imported from billing/actions, not defined here

export const setUpgradePopup = (open) => ({
  type: types.SET_UPGRADE_POPUP,
  payload: open
});

export const setRechargePopup = (open) => ({
  type: types.SET_RECHARGE_POPUP,
  payload: open
});

export const refreshPlanInfo = (count) => ({
  type: types.REFRESH_PLAN_INFO,
  payload: count
});

export const fetchPlanInfo = (subscriptionId, user) => async (dispatch) => {
  try {
    const response = await SPBackend.getPlanInfo(subscriptionId, user);
    const { data } = response;
    const { plan, subscription, account } = data;

    dispatch(setPlanInfo(plan));
    dispatch(setSubscriptionInfo(subscription));
    dispatch(setAccountUsage(account.Usage));
    // Use billing module's setBilling action
    dispatch(setBilling({
      customerId: account.Billing ? account.Billing.CustomerId : null,
      subscriptionId: subscription.id,
      subscriptionStatus: subscription.status
    }));
  } catch (error) {
    log('drawer getPlanInfo err: ', error.message);
  }
};